<template>
    <breadCrumbs title="Scroll Reveal" main="Animation" title1="Scroll Reveal" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <h3>Scroll Reveal Example</h3>
                    </div>
                    <div class="card-body">
                        <div class="row gallery my-gallery" id="aniimated-thumbnials" itemscope="">
                            <figure class="reveal col-xl-3 col-sm-6 box-col-33" v-for="(item, index) in img" :key="index"
                                @click="() => showImg(index)">
                                <img v-animate-onscroll.repeat="{ down: 'animated zoomInUp', up: 'animated rotateOut' }"
                                    class="img-thumbnail" :src="getImgUrl(item.image)" itemprop="thumbnail"
                                    alt="Image description">
                            </figure>
                        </div>
                        <vue-easy-lightbox :index="index" :visible="visible" :imgs="lightBoxImages" @hide="handleHide">
                        </vue-easy-lightbox>
                    </div>
                </div>
                <scrollReveal />
            </div>
        </div>
    </div>
</template>
<script>
import scrollReveal from "./scrollReveal.vue"
export default {
    components: {
        scrollReveal
    },
    data() {
        return {
            lightBoxImages: [],
            visible: false,
            index: '',
            img: [{ image: "lightgallry/01.jpg" },
            { image: "lightgallry/02.jpg" },
            { image: "lightgallry/03.jpg" },
            { image: "lightgallry/04.jpg" },
            { image: "lightgallry/05.jpg" },
            { image: "lightgallry/06.jpg" },
            { image: "lightgallry/07.jpg" },
            { image: "lightgallry/08.jpg" },
            { image: "lightgallry/09.jpg" },
            { image: "lightgallry/010.jpg" },
            { image: "lightgallry/011.jpg" },
            { image: "lightgallry/012.jpg" },
            { image: "lightgallry/013.jpg" },
            { image: "lightgallry/014.jpg" },
            { image: "lightgallry/015.jpg" },
            { image: "lightgallry/016.jpg" },
            { image: "lightgallry/01.jpg" },
            { image: "lightgallry/02.jpg" },
            { image: "lightgallry/03.jpg" },
            { image: "lightgallry/04.jpg" },
            { image: "lightgallry/05.jpg" },
            { image: "lightgallry/010.jpg" },
            { image: "lightgallry/011.jpg" },
            { image: "lightgallry/012.jpg" },
            ]
        }
    },
    methods: {
        showImg(index) {
            this.index = index
            this.visible = true
        },
        handleHide() {
            this.visible = false
        },
        getImgUrl(path) {
            return require('@/assets/images/' + path)
        }
    },
    mounted() {
        this.img.forEach(item => {
            this.lightBoxImages.push(require('@/assets/images/' + item.image))
        })
    }
}
</script>
